/** Resolve the Agent/Edge surface that owns `/api/cli/*` in every environment. */
export function getBlockLibraryCliApiBaseUrl(): string {
  if (import.meta.env.VITE_AGENT_API_URL) return import.meta.env.VITE_AGENT_API_URL;
  if (import.meta.env.VITE_BUILDER_API_URL) return import.meta.env.VITE_BUILDER_API_URL;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:8080';
  if (hostname === 'dev.segmently.ai' || hostname.includes('devsegmentlyai')) return 'https://dev-api.segmently.ai';
  if (hostname === 'stage.segmently.ai' || hostname.includes('stagesegmentlyai')) return 'https://stage-api.segmently.ai';
  return 'https://api.segmently.ai';
}

/** Resolve the Agent service for `/api/agent/*` lifecycle endpoints. */
export function getAgentApiBaseUrl(): string {
  if (import.meta.env.VITE_AGENT_API_URL) return import.meta.env.VITE_AGENT_API_URL;
  if (import.meta.env.VITE_BUILDER_API_URL) return import.meta.env.VITE_BUILDER_API_URL;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:8083';
  if (hostname === 'dev.segmently.ai' || hostname.includes('devsegmentlyai')) return 'https://dev-api.segmently.ai';
  if (hostname === 'stage.segmently.ai' || hostname.includes('stagesegmentlyai')) return 'https://stage-api.segmently.ai';
  return 'https://api.segmently.ai';
}
